import { Box, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "../../../shared/styles/useStyles";

interface HeaderLogoProps {
  logoUrl?: string;
}

function HeaderLogo({ logoUrl }: HeaderLogoProps) {
  const classes = useStyles();

  return (
    <Box
      height={"109px"}
      display={"flex"}
      alignItems={"center"}
      maxWidth={"1112px"}
      marginRight={"auto"}
      marginLeft={"auto"}
      className="pqrs-form"
    >
      {logoUrl ? (
        <img className="logo-img" src={logoUrl} alt="Logo" />
      ) : (
        <CircularProgress className={clsx(classes.btnLoading, "color-blue")} />
      )}
    </Box>
  );
}

export default HeaderLogo;
